import React from "react";
import "./css/grivance.css";
const GrievanceRedressal = () => {
  return (
    <>
      <div
        className="container mb-5"
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
        }}
      >
        <h1 style={{ textAlign: "center" }}> Grievance</h1>
        <b style={{ textAlign: "center" }}>
          If you are not happy with the solution provided reach out to Grievance
          Officer.
        </b>
        <div className="write-to-us-section mt-3">
          <h5 style={{ textAlign: "center", fontWeight: 700 }}>
            InstaPe Grievance Officer
          </h5>
          <p>
            <b>Name</b>: Mr. Durairaj Ponnusamy
          </p>
          <p>
            <b>Address</b>: InstaPe Synergies Private Limited, Tainwala House,
            Road no.18, MIDC, Marol Andheri (East), MUMBAI 400093{" "}
          </p>

          <p>
            <b>Phone number</b>: +91 86554 08338
          </p>
          <p>
            <b>Timings</b>: From 9:30am to 6:00pm (2nd and 4th Saturday Holiday){" "}
          </p>
          <p>
            <b> Email ID</b>:
            <a
              href="mailto:nodalofficer@instape.com"
              style={{ color: "blue", marginLeft: 2 }}
            >
              nodalofficer@instape.com
            </a>
          </p>
        </div>

        <div className="write-to-us-section mt-4">
          <h5 style={{ textAlign: "center", fontWeight: 700 }}>
            Suryoday Small Finance Bank Grievance Redressal Officer
            <br />
            (Digital Lending / Fintech Complaints)
          </h5>
          <p>
            <b>Name</b>: Mrs. Rekha Britto
          </p>
          <p>
            <b>Designation</b>: Vice President | Customer Service
          </p>
          <p>
            <b>Address</b>: 1101, Sharda Terraces, Plot No.65, Sector 11, CBD
            Belapur, Navi Mumbai – 400614
          </p>
          <p>
            <b>Contact No.</b>: 022-40941556
          </p>
          <p>
            <b>Email</b>:
            <a
              href="mailto:grievances.tpp@suryodaybank.com"
              style={{ color: "blue", marginLeft: 2 }}
            >
              grievances.tpp@suryodaybank.com
            </a>
          </p>
        </div>
      </div>
    </>
  );
};

export default GrievanceRedressal;
